import WarningInfo from './WarningInfo';

export default WarningInfo;
